/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Datumersteteilnahmelernfoerderung3Inputs */

const de__field_datumersteteilnahmelernfoerderung3 = /** @type {(inputs: _Field_Datumersteteilnahmelernfoerderung3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum erste Teilnahme Lernförderung`)
};

/**

* @param {_Field_Datumersteteilnahmelernfoerderung3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_datumersteteilnahmelernfoerderung3 = /** @type {((inputs?: _Field_Datumersteteilnahmelernfoerderung3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Datumersteteilnahmelernfoerderung3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_datumersteteilnahmelernfoerderung3(inputs)
});
export { _field_datumersteteilnahmelernfoerderung3 as "_field_datumErsteTeilnahmeLernfoerderung" }